import React from 'react'

function Trash ({ className, fill }) {
  return (
    <svg fill={fill} className={className} viewBox='0 0 448 448'>
      <path d='M0,53.332H448V74.668H0Zm0,0' />
      <path d='M362.668,448H85.332a42.791,42.791,0,0,1-42.664-42.668V64H64V405.332a21.4,21.4,0,0,0,21.332,21.336H362.668A21.4,21.4,0,0,0,384,405.332V64h21.332V405.332A42.791,42.791,0,0,1,362.668,448Zm0,0' />
      <path d='M128,160h21.332V341.332H128Zm0,0' />
      <path d='M298.668,64H277.332V21.332H170.668V64H149.332V0H298.668Zm0,0' />
      <path d='M213.332,160h21.336V341.332H213.332Zm0,0' />
      <path d='M298.668,160H320V341.332H298.668Zm0,0' />
    </svg>
  )
}

Trash.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default Trash
